export default "__VITE_ASSET__DjaeoWEU__"